/**
 * @desc 查询中台平台库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockSkuPlatformListQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/platform/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
